import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { Skeleton } from '@shared/components/Skeleton';
import type { PricingProps } from '../HotelTile.types';

export const Pricing: React.FC<PricingProps> = React.memo(({ price, loading }) => {
  const { tq } = useTranslation('sharedComponents');

  if (loading) {
    return (
      <Flex
        flexDirection="column"
        alignItems="flex-end"
        gap={1}
        flexShrink={0}
      >
        <Skeleton
          width={pxToRem(48)}
          height={pxToRem(20)}
          borderRadius={pxToRem(4)}
        />
        <Skeleton
          width={pxToRem(36)}
          height={pxToRem(14)}
          borderRadius={pxToRem(4)}
        />
      </Flex>
    );
  }

  if (!price?.current) return null;

  return (
    <Flex
      flexDirection="column"
      alignItems="flex-end"
      flexShrink={0}
    >
      <TextV2
        typographyVariant="hed4"
        color="mono14"
      >
        {price.current}
      </TextV2>
      {(price.original || price.percentOff) && (
        <Flex
          gap={1}
          alignItems="center"
        >
          {price.percentOff && (
            <TextV2
              typographyVariant="label3"
              color="accentGreen3"
            >
              {tq`${price.percentOff}% off`}
            </TextV2>
          )}
          {price.original && (
            <TextV2
              typographyVariant="label2"
              color="mono10"
              textDecoration="line-through"
            >
              {price.original}
            </TextV2>
          )}
        </Flex>
      )}
    </Flex>
  );
});

Pricing.displayName = 'HotelTile.Pricing';
